import React from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import '../styles/CrystalButton.css';

export default function CrystalGoogleButton({ onSuccess, onError, disabled = false }) {
  const login = useGoogleLogin({
    onSuccess: onSuccess,
    onError: onError
  });

  return (
    <button
      className="lux-button"
      onClick={() => !disabled && login()}
      disabled={disabled}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        filter: disabled ? 'grayscale(100%)' : 'none',
        // Preserve other styles or let CSS handle disabled
      }}
    >
      <div className="diamond-g-container">
        <div className="diamond-facets"></div>
        <div className="diamond-g">G</div>
      </div>
      Connexion Google
    </button>
  );
}
